import { AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import { IGetMyAdsPayload } from '../../models/payload/myAddsPayload';
import { IAds } from '../../models/post/ad';

import { RemoveEmptyFiledFromObject } from '../../utilities/helper/removeEmptyFiledFromObject';
import request from '../axios';

export const getMyAds = async (ctx: IGetMyAdsPayload, pageNumber: number) => {
  RemoveEmptyFiledFromObject(ctx);
  const { data }: { data: IAds } = await request.get(
    `/api/v2/store/my-posts?page=` + pageNumber,
    {
      params: {
        ...ctx,
      },
    } as AxiosRequestConfig,
  );
  return data;
};


export const deletePost = async (payload: IRemovePostPayload) => {
  const { data }: { data: IResponse } = await request.delete(
    `/api/v2/store/${payload.type}-post`,
    {
      headers: {} as AxiosRequestHeaders,
      data: { ...payload },
    },
  );
  return data;
};
